import React from "react";
import SearchPopup from "./searchPopup";
import { useSearchParams } from "react-router-dom";

const SearchPopupPage = () => {
    const [searchParams] = useSearchParams();

    const searchType = searchParams.get("type") || "Search";
    const targetInputId = searchParams.get("target") || "targetField";
    const apiUrl = decodeURIComponent(searchParams.get("url") || "");

    if (!apiUrl) return <div>Missing API URL</div>;

    return (
        <SearchPopup
            searchType={searchType}
            targetInputId={targetInputId}
            apiUrl={apiUrl}
            onClose={() => window.close()}
        />
    );
};

export default SearchPopupPage;
